module.exports = __webpack_public_path__ + "img/Receive_bg@3x.7259c1f4.png";